import styled from "@emotion/styled";

export const CheckedReportWrapper = styled.div({
    marginLeft: "20px",
    fontWeight: 700,
    lineHeight: "20px",
});
